import { Icon } from '@/components/Icon';
import { ReactNode } from 'react';
import { ControllerFieldState } from 'react-hook-form';
import { Platform, TextInput, TextInputProps, View } from 'react-native';
import { Text } from '@/components/Text';
import theme from '@/config/theme';
import { styles } from './styles';

interface EmailInputProps extends TextInputProps {
  field: any;
  fieldState: ControllerFieldState;
}

export const EmailInput = ({
  fieldState,
  field,
}: EmailInputProps): ReactNode => {
  const { value, onChange, onBlur } = field;
  const { error } = fieldState;

  const borderColor = error ? theme.colors.red : theme.colors.primary;
  const iconColor = error ? theme.colors.red : theme.colors.primary;

  return (
    <View style={styles.wrapper}>
      <View style={[styles.inputRow, { borderColor }]}>
        <Icon name="user" size={28} color={iconColor} />
        <TextInput
          id="email-input"
          style={[
            styles.textInput,
            Platform.OS === 'ios'
              ? {
                  lineHeight: 0,
                  color: theme.colors.newUI.therapist.textBlue100,
                }
              : { color: theme.colors.newUI.therapist.textBlue100 },
          ]}
          placeholder="E-Mail"
          autoComplete="off"
          placeholderTextColor={theme.colors.twGrey}
          autoCapitalize="none"
          textBreakStrategy="simple"
          onBlur={onBlur}
          onChangeText={onChange}
          value={value}
        />
      </View>
      <Text style={styles.errorText}>{error?.message}</Text>
    </View>
  );
};
